import { ProductCode, type AuthUser } from '@gb-ticket/shared-types';

import { platformProductTiles, type PlatformProductTile } from '@/platform/lib/products';

/** Module tiles on the intranet home: same rules as `/start`, minus Intranet itself. */
export function intranetHomeModuleTiles(user: AuthUser): PlatformProductTile[] {
  return platformProductTiles(user).filter((tile) => tile.code !== ProductCode.INTRANET);
}
